import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=663d8878&scoped=true&"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmation.vue?vue&type=style&index=0&id=663d8878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d8878",
  null
  
)

export default component.exports